module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"helpTranslate":"Help translate Central"}}')
  delete Component.options._Ctor
}
